export const ambassadorRegistrationPossibleLanguages = [
  { label: 'Arabic', value: 'Arabic' },
  { label: 'Czech', value: 'Czech' },
  { label: 'Dutch', value: 'Dutch' },
  { label: 'English', value: 'English' },
  { label: 'French', value: 'French' },
  { label: 'German', value: 'German' },
  { label: 'Italian', value: 'Italian' },
  { label: 'Japanese', value: 'Japanese' },
  { label: 'Polish', value: 'Polish' },
  { label: 'Portuguese', value: 'Portuguese' },
  { label: 'Slovak', value: 'Slovak' },
  { label: 'Spanish', value: 'Spanish' },
];

export const ambassadorRegistrationPossibleSiteTypes = [
  { label: 'Air', value: 'Air' },
  { label: 'Amazon Fresh', value: 'Amazon Fresh' },
  { label: 'AMXL', value: 'AMXL' },
  { label: 'AMXL FC', value: 'AMXL FC' },
  { label: 'AMXL DS', value: 'AMXL DS' },
  { label: 'AMXL SC', value: 'AMXL SC' },
  { label: 'AR Non Sortable', value: 'AR Non Sortable' },
  { label: 'AR Quick Deploy', value: 'AR Quick Deploy' },
  { label: 'AR Sortable', value: 'AR Sortable' },
  { label: 'Audible', value: 'Audible' },
  { label: 'Corporate office', value: 'Corporate office' },
  { label: 'Delivery Station', value: 'Delivery Station' },
  { label: 'Data Center', value: 'Data Center' },
  { label: 'Fresh Pickup', value: 'Fresh Pickup' },
  { label: 'Fulfillment Center', value: 'Fulfillment Center' },
  { label: 'GFC', value: 'GFC' },
  { label: 'Go', value: 'Go' },
  { label: 'GDC', value: 'GDC' },
  { label: 'Hub / Distribution Center', value: 'Hub / Distribution Center' },
  { label: 'InfraOps', value: 'InfraOps' },
  { label: 'IXD', value: 'IXD' },
  { label: 'Kariba', value: 'Kariba' },
  { label: 'Make on Demand', value: 'Make on Demand' },
  { label: 'Made by Amazon', value: 'Made by Amazon' },
  { label: 'Mixed', value: 'Mixed' },
  { label: 'Pantry', value: 'Pantry' },
  { label: 'Pillpack', value: 'Pillpack' },
  { label: 'ReLo', value: 'ReLo' },
  { label: 'Returns', value: 'Returns' },
  { label: 'Robotics', value: 'Robotics' },
  { label: 'RSR', value: 'RSR' },
  { label: 'Sort Center', value: 'Sort Center' },
  { label: 'SPP', value: 'SPP' },
  { label: 'SSD', value: 'SSD' },
  { label: 'Style', value: 'Style' },
  { label: 'Subsidiary', value: 'Subsidiary' },
  { label: 'Supplemental FC', value: 'Supplemental FC' },
  { label: 'Traditional Non-Sort', value: 'Traditional Non-Sort' },
  { label: 'TSSL', value: 'TSSL' },
  { label: 'Whole Foods', value: 'Whole Foods' },
  { label: 'XPT', value: 'XPT' },
  { label: 'Other', value: 'Other' },
];

export const ambassadorRegistrationPossibleCountries = [
  { label: 'Argentina', value: 'Argentina' },
  { label: 'Australia', value: 'Australia' },
  { label: 'Austria', value: 'Austria' },
  { label: 'Bahrain', value: 'Bahrain' },
  { label: 'Bangladesh', value: 'Bangladesh' },
  { label: 'Belgium', value: 'Belgium' },
  { label: 'Brazil', value: 'Brazil' },
  { label: 'Bulgaria', value: 'Bulgaria' },
  { label: 'Canada', value: 'Canada' },
  { label: 'Chile', value: 'Chile' },
  { label: 'China', value: 'China' },
  { label: 'Colombia', value: 'Colombia' },
  { label: 'Costa Rica', value: 'Costa Rica' },
  { label: 'Croatia', value: 'Croatia' },
  { label: 'Czech Republic', value: 'Czech Republic' },
  { label: 'Denmark', value: 'Denmark' },
  { label: 'Egypt', value: 'Egypt' },
  { label: 'Estonia', value: 'Estonia' },
  { label: 'Finland', value: 'Finland' },
  { label: 'France', value: 'France' },
  { label: 'Germany', value: 'Germany' },
  { label: 'Greece', value: 'Greece' },
  { label: 'Guatemala', value: 'Guatemala' },
  { label: 'Honduras', value: 'Honduras' },
  { label: 'Hong Kong', value: 'Hong Kong' },
  { label: 'Hungary', value: 'Hungary' },
  { label: 'India', value: 'India' },
  { label: 'Indonesia', value: 'Indonesia' },
  { label: 'Ireland', value: 'Ireland' },
  { label: 'Israel', value: 'Israel' },
  { label: 'Italy', value: 'Italy' },
  { label: 'Jamaica', value: 'Jamaica' },
  { label: 'Japan', value: 'Japan' },
  { label: 'Jordan', value: 'Jordan' },
  { label: 'Kenya', value: 'Kenya' },
  { label: 'Korea, Republic of', value: 'Korea, Republic of' },
  { label: 'Kuwait', value: 'Kuwait' },
  { label: 'Luxembourg', value: 'Luxembourg' },
  { label: 'Malaysia', value: 'Malaysia' },
  { label: 'Mauritius', value: 'Mauritius' },
  { label: 'Mexico', value: 'Mexico' },
  { label: 'Morocco', value: 'Morocco' },
  { label: 'Netherlands', value: 'Netherlands' },
  { label: 'New Zealand', value: 'New Zealand' },
  { label: 'Nicaragua', value: 'Nicaragua' },
  { label: 'Nigeria', value: 'Nigeria' },
  { label: 'Norway', value: 'Norway' },
  { label: 'Peru', value: 'Peru' },
  { label: 'Philippines', value: 'Philippines' },
  { label: 'Poland', value: 'Poland' },
  { label: 'Portugal', value: 'Portugal' },
  { label: 'Puerto Rico', value: 'Puerto Rico' },
  { label: 'Romania', value: 'Romania' },
  { label: 'Saudi Arabia', value: 'Saudi Arabia' },
  { label: 'Serbia', value: 'Serbia' },
  { label: 'Singapore', value: 'Singapore' },
  { label: 'Slovakia', value: 'Slovakia' },
  { label: 'Slovenia', value: 'Slovenia' },
  { label: 'South Africa', value: 'South Africa' },
  { label: 'Spain', value: 'Spain' },
  { label: 'Sweden', value: 'Sweden' },
  { label: 'Switzerland', value: 'Switzerland' },
  { label: 'Taiwan', value: 'Taiwan' },
  { label: 'Thailand', value: 'Thailand' },
  { label: 'Turkey', value: 'Turkey' },
  { label: 'United Arab Emirates', value: 'United Arab Emirates' },
  { label: 'United Kingdom', value: 'United Kingdom' },
  { label: 'United States', value: 'United States' },
  { label: 'Uruguay', value: 'Uruguay' },
  { label: 'Vietnam', value: 'Vietnam' },
  { label: 'Other', value: 'Other' },
];
